"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../PageContentList/util");

var SectionType;

(function (SectionType) {
  SectionType[SectionType["Empty"] = 0] = "Empty";
  SectionType[SectionType["Text"] = 1] = "Text";
  SectionType[SectionType["TextMedia"] = 2] = "TextMedia";
  SectionType[SectionType["Mixed"] = 3] = "Mixed";
})(SectionType = exports.SectionType || (exports.SectionType = {}));
/**
 * Determines the type of a section by analyzing its content elements
 */


function inferSectionType(sectionData) {
  var sectionElements = sectionData.array('content');
  var sectionType = SectionType.Empty;

  for (var index = 0; index < sectionElements.length; index += 1) {
    var element = sectionElements[index];
    var elementRenderMode = util_1.getVisualType(element);

    if (sectionType === SectionType.Empty) {
      if (elementRenderMode === util_1.VisualRenderMode.Text) {
        sectionType = SectionType.Text;
      }

      if (elementRenderMode === util_1.VisualRenderMode.TextMedia) {
        sectionType = SectionType.TextMedia;
      }

      continue;
    }

    if (sectionType === SectionType.Text && elementRenderMode === util_1.VisualRenderMode.TextMedia || sectionType === SectionType.TextMedia && elementRenderMode === util_1.VisualRenderMode.Text) {
      return SectionType.Mixed;
    }
  }

  return sectionType;
}

exports.inferSectionType = inferSectionType;